import * as yup from 'yup';
import React, { useEffect } from 'react';
import { buildValidationObject } from '../../../../util/form';
import { useLang } from '../../../../util/lang';

const imageValidate = yup
    .mixed()
    .transform((value) => (value === null ? null : value))
    .required('Required');

// Explain: label is the key in translation
const retrackReportQuestionConfig = (direction = 'upper', formValues = undefined) => {
    const obj = {
        dateInput: {
            component: 'LeftTextFieldRhf',
            name: `created_date`,
            label: 'date',
        },
        caseIdInput: {
            component: 'RightTextFieldRhf',
            name: `case_id`,
            label: 'caseId',
        },
        alignerStepComparison: {
            component: 'AlignerStepRhf',
            name: `${direction}_alignerStepComparison`,
            label: {
                alignerStep: 'alignerStep',
                alignerStepComparison: 'alignerStepComparison',
            },
            validation: yup.number().required('Required').typeError('Number is required'),
        },
        newScanDataCloseStep: {
            component: 'NewScanRhf',
            name: `${direction}_newScanDataCloseStep`,
            label: {
                newScan: 'newScan',
                greenText: 'greenText',
                pinkText: 'pinkText',
            },
            validation: yup.number().required('Required').typeError('Number is required'),
        },
        occlusal: {
            component: 'UploadPhotoRhf',
            name: `${direction}_occlusal_image`,
            label: 'Occulusal View',
            validation: imageValidate,
        },
        frontal: {
            component: 'UploadPhotoRhf',
            name: `${direction}_frontal_image`,
            label: 'Frontal View',
            validation: imageValidate,
        },
        leftBuccal: {
            component: 'UploadPhotoRhf',
            name: `${direction}_leftBuccal_image`,
            label: 'Left Buccal View',
            validation: imageValidate,
        },
        rightBuccal: {
            component: 'UploadPhotoRhf',
            name: `${direction}_rightBuccal_image`,
            label: 'Right Buccal View',
            validation: imageValidate,
        },
        // closeMatch: {
        //     component: 'ClosestMatchAlignerStepRhf',
        //     name: `${direction}_closeMatch`,
        //     label: {
        //         newScanApprovedTreatment: 'newScanApprovedTreatment',
        //         newScanApprovedTreatmentStep: 'newScanApprovedTreatmentStep'
        //     },
        //     validation: yup.number().required("Required").typeError('Number is required'),
        // },
        // alignerStepSentToClinic: {
        //     component: 'AlignerStepSentToClinic',
        //     name: `${direction}_alignerStepSentToClinic`,
        //     label: {
        //         sentToClinicTherefore: 'sentToClinicTherefore',
        //         sentToClinicTo: 'sentToClinicTo',
        //         sentToClinic: 'will be sent to the clinic.'
        //     },
        //     option: [
        //         {
        //             name: `${direction}_alignerStepStart`,
        //             validation: yup.number().required("Required").typeError('Number is required'),
        //         },
        //         {
        //             name: `${direction}_alignerStepEnd`,
        //             validation: yup.number().required("Required").typeError('Number is required'),
        //         }
        //     ]
        // },
    };

    return obj;
};

export const retrackReportUpperQuestions = (formValues = undefined) => {
    const obj = retrackReportQuestionConfig('upper', formValues);
    return obj;
};
export const retrackReportLowerQuestions = (formValues = undefined) => {
    const obj = retrackReportQuestionConfig('lower', formValues);
    return obj;
};

// @ts-ignore
export const retrackReportUpperQuestionsValidationSchema = yup
    .object()
    .shape(buildValidationObject(retrackReportUpperQuestions()));
// @ts-ignore
export const retrackReportLowerQuestionsValidationSchema = yup
    .object()
    .shape(buildValidationObject(retrackReportLowerQuestions()));
